import React from 'react';
import announcement from '../../../../../../../../assets/special-announcement.png';

const MassMessage = ({ message }) => (
  <li className="message message--mass">
    <div>
      <img
        alt="Special Announcement"
        className="mass-message-announcement"
        src={announcement}
      />
      <span className="mass-message-title">Special Announcement</span>
      <p>{message.message}</p>
    </div>
  </li>
);

export default MassMessage;
